import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  static values = {
    progress: { type: Number, default: 10 }
  }

  static targets = ["progressCircle", "progressText"]

  connect() {
    this.fireConfetti()
    this.animateProgress()
  }

  fireConfetti() {
    // Fire confetti from both sides
    const duration = 3000
    const end = Date.now() + duration

    const colors = ['#f97316', '#fb923c', '#fbbf24', '#10b981', '#3b82f6']

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: colors
      })
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: colors
      })

      if (Date.now() < end) {
        requestAnimationFrame(frame)
      }
    }

    // Initial burst
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: colors
    })

    frame()
  }

  animateProgress() {
    if (!this.hasProgressCircleTarget) return

    const circle = this.progressCircleTarget
    const radius = circle.r.baseVal.value
    const circumference = radius * 2 * Math.PI

    circle.style.strokeDasharray = `${circumference} ${circumference}`
    circle.style.strokeDashoffset = circumference

    // Animate to target progress
    setTimeout(() => {
      const offset = circumference - (this.progressValue / 100) * circumference
      circle.style.strokeDashoffset = offset
    }, 100)

    // Animate the text counter
    if (this.hasProgressTextTarget) {
      this.animateCounter(0, this.progressValue, 1500)
    }
  }

  animateCounter(start, end, duration) {
    const startTime = performance.now()

    const update = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      // Ease out cubic
      const easeOut = 1 - Math.pow(1 - progress, 3)
      const current = Math.round(start + (end - start) * easeOut)

      this.progressTextTarget.textContent = `${current}%`

      if (progress < 1) {
        requestAnimationFrame(update)
      }
    }

    requestAnimationFrame(update)
  }
}
